export default __webpack_public_path__ + "static/media/invite_friends.8ea562e5.png";